import { useEffect, useState } from "react";
import { listProposals } from "@/lib/api";
import { Paperclip, FileText } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function Attachments() {
  const [items, setItems] = useState([]);
  const nav = useNavigate();
  useEffect(() => { listProposals().then(setItems); }, []);

  const allAtts = items.flatMap((p) => (p.attachments || []).map((a) => ({ ...a, proposal: p })));

  return (
    <div className="max-w-5xl mx-auto px-8 py-12 fade-in">
      <div className="label-eyebrow mb-3">Library</div>
      <h1 className="font-display text-4xl md:text-5xl font-medium tracking-tight">Attachments</h1>
      <p className="text-sm text-zinc-500 mt-2 max-w-md">
        All files attached across your proposals — case studies, security docs, pricing sheets.
      </p>

      <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {allAtts.length === 0 && (
          <div className="col-span-full border border-dashed border-zinc-200 rounded-2xl p-16 text-center bg-white">
            <Paperclip className="mx-auto text-zinc-400 mb-3" />
            <h3 className="font-display text-lg">No attachments yet</h3>
            <p className="text-sm text-zinc-500 mt-1">Open a proposal and upload files from the right panel.</p>
          </div>
        )}
        {allAtts.map((a) => (
          <button
            key={a.id}
            onClick={() => nav(`/proposals/${a.proposal.id}`)}
            data-testid={`global-attachment-${a.id}`}
            className="text-left rounded-xl bg-white border border-[#E8EAF3] p-6 hover:shadow-[0_12px_32px_-16px_rgba(1, 27, 144,0.3)] hover:border-[#011B90]/30 transition-all"
          >
            <FileText className="text-zinc-500 mb-3" />
            <div className="font-medium text-sm truncate">{a.name}</div>
            <div className="text-xs text-zinc-500 mt-1">{a.proposal.title}</div>
            <div className="text-[10px] text-zinc-400 mt-2">{Math.round((a.size || 0) / 1024)} KB</div>
          </button>
        ))}
      </div>
    </div>
  );
}
